module.exports = __webpack_public_path__ + "img/sti_dg_woodpacking.df86473f.svg";